import React from 'react';
import styled from 'styled-components';


const SectWrapper = styled.div`
    padding: 0 12rem 3rem;
    min-height: 150px;

    p {
        text-align: center;
    }

    @media (max-width: 1400px) {
       padding: 0 10rem 3rem;
    }

    @media (max-width: 1080px) {
       padding: 0 8rem 3rem;
    }
    @media (max-width: 750px) {
        padding: 0 6rem 3rem;
    }
`;


const SectParagraph = (props) => {
    return (
        <SectWrapper>
            <h2>{props.title}</h2>
            <p>{props.text}</p>
        </SectWrapper>
    )
}

export default SectParagraph